export const FRAMES_PER_SECOND = 60
export const FRAME_DURATION = 1000 / FRAMES_PER_SECOND
